import { __generator } from "tslib";
import { all, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { DEVIATIONS_PER_FETCH, MEDIA_POPUP_CUSTOM_DEVIATION_SET_STREAM_ID, } from '../constants';
import { normalizeDeviations } from '../../redux/normalizr/helpers';
function handleInitCustomSetDeviationStream(action) {
    var deviations, streamId, _a, ids, entities, isStreamInitialized;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                deviations = action.payload;
                streamId = MEDIA_POPUP_CUSTOM_DEVIATION_SET_STREAM_ID;
                _a = normalizeDeviations(deviations), ids = _a.result, entities = _a.entities;
                return [4 /*yield*/, select(selectors.isInitialized, streamId)];
            case 1:
                isStreamInitialized = _b.sent();
                if (isStreamInitialized) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, all([
                        put(withOffset.actions.initialize({
                            streamId: streamId,
                            itemsPerFetch: DEVIATIONS_PER_FETCH,
                            items: ids,
                            entities: entities,
                        })),
                        put(withOffset.actions.fetch(streamId)),
                    ])];
            case 2:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export default handleInitCustomSetDeviationStream;
//# sourceMappingURL=initCustomSetDeviationStream.js.map